
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`«Die Klimaerwärmung gibt es definitiv! Aber ich habe mir noch nie viel Gedanken um die Zusammenhänge gemacht oder darum, ob das Fliegen dabei eine Rolle spielt. Ich und mein Mann fliegen sowieso nur einmal pro Jahr, immer in die Ferien. Zu Hause fahren wir Auto, mit dem Velo zu fahren, kommt für uns nicht infrage. Klimakompensation? Da müsste ich schon genau wissen, wofür mein Geld dann eingesetzt wird.»`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;